var sw = sw || {};


// Hero slider
// -----------------------------------------------------------------
sw.heroSlider = function() {

    var $slider = $('.js_heroSlider');

    if (!$slider.length) {
        return;
    }

    var mySwiper = new Swiper('.js_heroSlider', {
        loop: true,
        direction: 'horizontal',
        slidesPerView: 1,
        loopedSlides: 1,
        spaceBetween: 0,
        autoHeight: true,
        effect: 'fade',

        // Autoplay
        autoplay: {
            delay: 4000,
        },

        // Pagination
        pagination: {
            clickable: true
        },

        // Arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })

};



// Panorama slider
// -----------------------------------------------------------------
sw.panoramaSlider = function() {

    var $slider = $('.js_panoramaSlider');

    if (!$slider.length) {
        return;
    }

    var mySwiper = new Swiper('.js_panoramaSlider', {
        loop: true,
        direction: 'horizontal',
        slidesPerView: 1,
        // loopedSlides: 1,
        spaceBetween: 0,

        // Pagination
        pagination: {
            clickable: true
        },

        // Arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
            // >= 768px
            480: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            // >= 1024px
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            1366: {
              slidesPerView: 4,
              spaceBetween: 30
            }
        }
    })

};





$(document).ready(function (){
    sw.heroSlider();
    sw.panoramaSlider();
});